module.exports = __webpack_public_path__ + "media/images/Amsale-Dresses-f3116215.webp";